<template>
  <v-row>
    <v-col cols="12" class="text-center pa-1">
      <v-stepper
        v-model="orderStatusProgress[orderStatus].value"
        vertical
        class="elevation-0"
      >
        <v-stepper-step
          :complete="orderStatusProgress[orderStatus].value > 1"
          step="1"
        >
          執筆
        </v-stepper-step>
        <v-stepper-content step="1" class="text-left caption pa-3">
          読みたくなる記事を執筆しましょう
        </v-stepper-content>
        <v-stepper-step
          v-if="orderIsMaster"
          :complete="orderStatusProgress[orderStatus].value > 1.5"
          step="1.5"
        >
          コピーチェック
        </v-stepper-step>
        <v-stepper-content
          v-if="orderIsMaster"
          step="1.5"
          class="text-left caption pa-3"
        >
          コピーチェックの確認中です
        </v-stepper-content>
        <v-stepper-step
          :complete="orderStatusProgress[orderStatus].value > 2"
          step="2"
        >
          検収
        </v-stepper-step>
        <v-stepper-content step="2" class="text-left caption pa-3">
          現在編集部が記事をチェックしています
        </v-stepper-content>
        <v-stepper-step
          :complete="orderStatusProgress[orderStatus].value == 3"
          step="3"
        >
          完了
        </v-stepper-step>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    orderStatus: {
      type: String,
      required: true
    },
    orderIsMaster: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      orderStatusProgress: {
        writing: {
          value: 1
        },
        under_inspection: {
          value: 2
        },
        completed: {
          value: 3
        },
        client_completed: {
          value: 3
        },
        under_detection: {
          value: 1.5
        }
      }
    }
  }
}
</script>
